import { createSelector } from 'reselect';
import { KEY } from './';
import { GlobalState } from 'store/types';

const getAreasState = (state: GlobalState) => state[KEY];

const selectAreas = createSelector(getAreasState, (areas) => areas.areas);

const selectAction = createSelector(getAreasState, (areas) => areas.action);

const selectCreatedArea = createSelector(getAreasState, (state) => state.createdArea);

export const selectors = {
  selectAreas,
  selectAction,
  selectCreatedArea
};
